/**
 * Un monto en colones enteros.
 *
 * `type="text"` con `inputMode="numeric"` y no `type="number"`: el de número
 * deja escribir «1e5» y «12.5», cambia el valor con la rueda del mouse encima
 * del campo —sin que nadie lo note— y en algunos navegadores dibuja flechitas
 * que en un formulario de tarifas no sirven para nada.
 *
 * Solo deja pasar dígitos, y por eso lo que sale de acá es SIEMPRE un entero
 * en colones: no hay nada que «limpiar» después, cuando ya nadie se acuerda de
 * por qué habría que hacerlo.
 */
interface MoneyFieldProps {
  id: string;
  label: string;
  help?: string;
  /** `null` es «vacío», que puede significar algo distinto de cero. */
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function MoneyField({
  id,
  label,
  help,
  value,
  onChange,
  placeholder = '0',
  disabled = false,
}: MoneyFieldProps): JSX.Element {
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      {help !== undefined && (
        <span className="help" id={`${id}-help`}>
          {help}
        </span>
      )}
      <span className="money">
        <span aria-hidden="true">₡</span>
        <input
          id={id}
          type="text"
          inputMode="numeric"
          autoComplete="off"
          disabled={disabled}
          placeholder={placeholder}
          aria-describedby={help === undefined ? undefined : `${id}-help`}
          value={value === null ? '' : String(value)}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, '');
            onChange(digits === '' ? null : Number.parseInt(digits, 10));
          }}
        />
      </span>
    </div>
  );
}
